<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">充电时长包订单</h3>
        <div class="block-options">
          <screenTime :isToday="'0'" @changePage="changePage"></screenTime>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnPilePackage"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">时长包订单</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('CREATE_TIME',$event)"
                      >#</th>
                      <th
                        class="text-left sorting"
                        style="min-width:110px;"
                        @click="getList('CREATE_TIME',$event)"
                      >时间</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('PACKAGE_ORDER_ID',$event)"
                      >订单号</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('SITE_NAME',$event)"
                      >适用范围</th>
                      <th
                        class="text-left sorting"
                        style="width: 110px;min-width: 110px;"
                        @click="getList('PACKAGE_TYPE',$event)"
                      >时长包类型</th>
                      <th
                        class="text-left sorting"
                        style="width: 110px;min-width: 110px;"
                        @click="getList('DESCRIPTION ',$event)"
                      >时长包名</th>
                      <th
                        class="text-left sorting"
                        style="min-width:105px;"
                        @click="getList('DURATION',$event)"
                      >有效时长</th>
                      <th
                        class="text-left sorting"
                        style="min-width:90px;"
                        @click="getList('PAY_MONEY',$event)"
                      >价格(元)</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:95px;"
                        @click="getList('PAY_TYPE',$event)"
                      >支付方式</th>
                      <th
                        class="text-center d-xl-table-cell no-print sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('PAY_STATE',$event)"
                      >支付状态</th>
                    </tr>
                  </thead>
                  <tbody v-if="userPackages.length">
                    <tr v-for="(item, i) in userPackages" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-md-table-cell">{{ item.CREATE_TIME }}</td>
                      <td class="text-left">
                        <div class="text-over" style="width:90px">{{ item.PACKAGE_ORDER_ID }}</div>
                      </td>
                      <td class="text-left d-md-table-cell">{{ item.SITE_NAME }}</td>
                      <td
                        class="text-left"
                      >{{item.PACKAGE_TYPE==1?"普通":item.PACKAGE_TYPE==2||item.PACKAGE_TYPE==4?"月底清零":""}}</td>
                      <td class="text-left d-md-table-cell">{{ item.DESCRIPTION }}</td>
                      <td class="text-left d-md-table-cell">{{ item.DURATION  }}小时</td>
                      <td class="text-left d-md-table-cell">{{ changeTwoDecimal(item.PAY_MONEY) }}</td>
                      <td class="text-left d-md-table-cell">{{ showPayType(item.PAY_TYPE)}}</td>

                      <td class="text-center d-xl-table-cell no-print" style="min-width:80px;">
                        <span
                          class="badge badge-pill"
                          :class="{'badge-success':item.PAY_STATE=='1'||!item.PAY_STATE,'badge-secondary':item.PAY_STATE!='1'&&item.PAY_STATE}"
                        >{{item.PAY_STATE=='1'||!item.PAY_STATE?'成功':'失败'}}</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="userPackages && userPackages.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      userPackages: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      created: false,
      clipboard: null,
      sorting: "",
      orderBy: false,
      content: ""
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    // this.getEntry()
    this.getList();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    showPayType(val) {
      switch (val) {
        case "0":
          return "钱包余额";
        case "1":
          return "微信";
        case "2":
          return "支付宝";
        case "3":
          return "其它";
      }
    },
    changePage(val) {
      this.page = val;
    },

    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/User/GetUserPackage/${this.$route.params.id}/${this.page}/${this.pageSize}`,

          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr;
      if (this.$route.name == "pileWhiteUser") {
        copyStr = document.getElementsByTagName("section")[2].innerText;
      }
      var btn = document.getElementById("copybtnPilePackage");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/User/GetUserPackage/${this.$route.params.id}/${this.page}/${this.pageSize}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userPackages = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatTimeToDate(val) {
      return Util.formatTimeToDate(val);
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>